var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUserLockFilled = function SvgUserLockFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 14.537V13c0-2.206-1.794-4-4-4s-4 1.794-4 4v1.537A4 4 0 0 0 12 18v2c0 2.206 1.794 4 4 4h4c2.206 0 4-1.794 4-4v-2c0-1.477-.805-2.77-2-3.463M18 20.5a1.5 1.5 0 1 1 .001-3.001A1.5 1.5 0 0 1 18 20.5m2-6.5h-4v-1c0-1.103.897-2 2-2s2 .897 2 2zM8 12c3.309 0 6-2.691 6-6s-2.691-6-6-6-6 2.691-6 6 2.691 6 6 6m2 8c0 1.535.58 2.938 1.532 4H1a1 1 0 0 1-1-1v-.729c0-4.115 2.993-7.76 7.083-8.219a8 8 0 0 1 2.766.164c.616.146.887.839.637 1.42A6 6 0 0 0 10 18z"
  })));
};
export default SvgUserLockFilled;